export const config = {
  title: "LVC Construction Fairfield",
  meta: {
    description:
      "LVC Construction Fairfield offers expert residential and commercial construction services across Fairfield, CT. Built on integrity, delivered with quality.",
    keywords: [
      "Construction Fairfield CT",
      "LVC Construction",
      "Home Renovation Fairfield",
      "Remodeling Contractor Connecticut",
      "Long View Construction Fairfield",
    ],
    author: "LVC Construction Fairfield",
    canonicalUrl: "https://longviewconstruction.net/",
  },
  sections: {
    header: {
      businessName: "LVC Construction Fairfield",
    },
    sectionB: {
      heroTitle: "Reliable Construction Backed by Experience",
      heroSubtitle: "Quality craftsmanship for your home or business",
      learnAboutText: "Explore Our Services",
      phoneNumber: "3472613523",
      phoneLabel: "(347) 261-3523",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/810293400/photo/female-architect-and-two-consruction-workers-on-a-construction-site.jpg?s=612x612&w=0&k=20&c=HbzFZV5vkc5I8hEomPqtz_WoJwO4RbcIKOWIVvV_3us=",
      cardData: [
        {
          title: "Home Renovation",
          description:
            "From kitchens to basements, we handle complete interior and exterior remodels.",
        },
        {
          title: "New Construction",
          description:
            "Build your dream home with experienced contractors and reliable project management.",
        },
        {
          title: "Commercial Projects",
          description:
            "Functional and durable commercial construction solutions tailored to your needs.",
        },
      ],
      description:
        "At LVC Construction Fairfield, we deliver premium construction services with a focus on quality, integrity, and customer satisfaction. Serving Fairfield, CT and surrounding areas.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive construction services for residential and commercial clients in Connecticut.",
      cards: [
        {
          title: "Kitchen & Bathroom Remodeling",
          description:
            "Custom cabinetry, tile work, plumbing, and full renovations.",
          imageSrc:
            "https://img1.wsimg.com/isteam/ip/b28e5ce0-edba-478c-9f9d-efcfe5a37a50/IMG_3457.jpg/:/rs=w:2560,h:1920",
          imageAlt: "Kitchen Remodeling",
        },
        {
          title: "Roofing & Siding",
          description:
            "Protect your home with professional roof repair and siding upgrades.",
          imageSrc:
            "https://media.istockphoto.com/id/1175090625/photo/roof-repair-construction-worker-roofer-man-roofing-security-rope.jpg?s=612x612&w=0&k=20&c=SclRJKkVmGqOZR0jSI7C82nco2QFXWxTGNQ-MCRyVmU=",
          imageAlt: "Roofing Services",
        },
        {
          title: "Interior & Exterior Painting",
          description:
            "Flawless finishes to enhance and protect your home or building.",
          imageSrc:
            "https://img1.wsimg.com/isteam/ip/b28e5ce0-edba-478c-9f9d-efcfe5a37a50/IMG_5988.jpg/:/rs=w:2560,h:1920",
          imageAlt: "Painting Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Deck & Porch Construction",
        "Flooring Installation",
        "Drywall & Framing",
        "Window & Door Replacement",
        "Basement Finishing",
        "Fence Installation",
        "Garage Remodeling",
        "Demolition & Cleanup",
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://img1.wsimg.com/isteam/ip/b28e5ce0-edba-478c-9f9d-efcfe5a37a50/IMG_2682.jpg/:/rs=w:2560,h:1920",
        alt: "LVC Construction Team",
      },
      aboutText: [
        "LVC Construction Fairfield is a full-service general contracting company with years of experience in residential and commercial projects.",
        "We are dedicated to delivering high-quality results while maintaining clear communication and accountability throughout every phase of your project.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "LVC Construction Fairfield Logo",
      businessName: "LVC Construction Fairfield",
      contact: {
        phone: "3472613523",
        phoneLabel: "(347) 261-3523",
        email: "lvccONSTRUCTIONFAIRFIELD@gmail.com",
        website: "https://longviewconstruction.net/",
        address: "85 Long View Ave, Fairfield, CT 06824",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "85 Long View Ave, Fairfield, CT 06824",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3100.928810733697!2d-73.257291!3d41.1460076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e80e5ccf68d6f3%3A0x63e0a7d2a2b438d!2s85%20Long%20View%20Ave%2C%20Fairfield%2C%20CT%2006824%2C%20USA!5e0!3m2!1sen!2sus!4v1717500000000",
    },
  },
};

export default config;
